import * as React from "react";
export function Grid(_ref) {
  let {
    children,
    columns = 1,
    alignItems,
    gap = 4,
    colSpan = 1,
    rowSpan = 1
  } = _ref;
  const inlineStyles = React.useMemo(() => {
    const gridGapPxValue = gap * 4; // spacing scale is in increments of 4px

    return {
      display: "grid",
      width: "100%",
      gridTemplateColumns: `repeat(${columns}, minmax(10px, 1fr))`,
      // Set column min width to 10px to avoid it going to min-content.
      alignItems,
      gap: gridGapPxValue,
      gridColumn: colSpan > 1 ? `auto / span ${colSpan}` : "",
      gridRow: rowSpan > 1 ? `auto / span ${rowSpan}` : ""
    };
  }, [columns, colSpan, rowSpan, alignItems, gap]);
  return /*#__PURE__*/React.createElement("div", {
    style: inlineStyles
  }, children);
}
function GridItem(_ref2) {
  let {
    colStart = "auto",
    colSpan = 1,
    rowStart = "auto",
    rowSpan = 1,
    visible = "VISIBLE",
    children
  } = _ref2;
  const inlineStyle = React.useMemo(() => ({
    gridColumn: colSpan !== 1 ? `${colStart} / span ${colSpan}` : "",
    gridRow: rowSpan !== 1 ? `${rowStart} / span ${rowSpan}` : "",
    visibility: visible === "HIDDEN_LEAVE_HOLE" ? "hidden" : undefined,
    display: visible === "HIDDEN_REMOVE_FIELD" ? "none" : undefined
  }), [colStart, colSpan, rowStart, rowSpan, visible]);
  return /*#__PURE__*/React.createElement("div", {
    style: inlineStyle
  }, children);
}
Grid.Item = GridItem;